import React from 'react';

//GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, REPORTS, SETTINGS } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { makePath } from 'functions.js';

//GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// GLOBAL COMPONENTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from 'columns';

// LOCAL COMPONENTS
import UserName from '../parts/UserName';

// MAIN COMPONENT
const Categories = () => (
  <Main>
    <Title title="Categories" tools={<Title.AddRecord label="Category" />} />
    <Filters>
      <Filters.Button.Active />
    </Filters>
    <Table mobilePreviewKeys={['report_category_name', 'is_active']} />
  </Main>
);

// EXPORT
export default getListData(Categories, {
  key: 'reportCategories',
  path: makePath(INTERFACE.settings, SETTINGS.reports, REPORTS.categories),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.reports.category.list
  },
  columns: [
    {
      key: 'report_category_name',
      label: 'Category',
      width: 200
    },
    {
      ...COLUMNS.active,
      tooltip: 'Only active categories will be available while creating report/dashboard widgets.'
    },
    COLUMNS.updatedOn,
    {
      key: 'updated_user',
      label: 'Updated By',
      component: UserName,
      width: 80
    }
  ],
  actions: [ACTIONS.edit('report_category_id')]
});
